import { useState } from "react";
import { Link } from "react-router-dom";
import { FileText, User } from "lucide-react";

import { shortName } from "../navSections";
import { useMemberProfile } from "../useMemberProfile";
import { ConnectionError } from "../components/ConnectionError";
import { BlockedNotice } from "../components/forms";
import { Loading, Unavailable } from "../components/kit";
import { V3Title, V3Columns, V3Field, V3Actions, AsideCard, V3_PRIMARY, V3_SECONDARY } from "../components/v3";

// M41 – country and time zone have no Core field yet (contract A.4.6 / C.2); region = own city, language = German only.
export default function Region() {
  const p = useMemberProfile();
  const [blocked, setBlocked] = useState(false);
  if (p.error) return <ConnectionError onRetry={p.load} />;
  if (!p.data) return <Loading />;
  const prof = p.data.profile;
  const name = shortName(prof.name);
  return (
    <div data-testid="member-region">
      <V3Title title="Land und Region einstellen" testid="region-title" intro="Land, Sprache und Zeitzone sind unabhängig voneinander wählbar." />
      <V3Columns layout="app" aside={<>
        <AsideCard icon={FileText} title="Ausgewählter Vorgang" text={prof.city || "Region"} />
        <AsideCard icon={User} tone="white" title="Verantwortung" text={name ? `${name} · Mitglied` : "Mitglied"} />
      </>} main={
        <div data-m="M41">
          <V3Field id="region-country" label="Land" value="Noch nicht festgelegt" readOnly hint="Noch nicht verfügbar – der gemeinsame Core speichert noch kein Land." />
          <V3Field id="region-language" label="Sprache" value="Deutsch" readOnly hint="Die Mitglieder-App ist derzeit nur auf Deutsch verfügbar." />
          <V3Field id="region-city" label="Region" value={prof.city || "Noch nicht angegeben"} readOnly hint="Deine Stadt aus dem Konto. Andere sehen nie eine genaue Adresse." />
          <V3Field id="region-timezone" label="Zeitzone" value="Noch nicht festgelegt" readOnly hint="Noch nicht verfügbar – der gemeinsame Core speichert noch keine Zeitzone." />
          {blocked
            ? <BlockedNotice what="gespeichert" testid="region-blocked">Land und Zeitzone können erst gespeichert werden, wenn der gemeinsame Core diese Felder anbietet.</BlockedNotice>
            : <Unavailable testid="region-unavailable">Land und Zeitzone sind noch nicht einstellbar. Es wird nichts geändert.</Unavailable>}
          <V3Actions>
            <button type="button" onClick={() => setBlocked(true)} className={V3_PRIMARY} data-testid="region-submit">Änderungen prüfen</button>
            <Link to="/einstellungen" className={V3_SECONDARY} data-testid="region-cancel">Abbrechen</Link>
          </V3Actions>
        </div>
      } />
    </div>
  );
}
